import { isSet } from '../utils/isSet';
import EmblaCarousel from 'embla-carousel';
import { setupLazyLoadImage } from '../functions/emblaCarouselLazyLoad';
import ClassNames from 'embla-carousel-class-names';

class TimelineVideo {
    constructor (domNode) {
        this.domNode = domNode;
        this.timestampElms = Array.from(this.domNode.querySelectorAll('[data-timestamp]'));
        this.emblaElm = this.domNode.querySelector('.embla--js');
        this.videoElm = this.domNode.querySelector('video');
        this.posterElm = this.domNode.querySelector('.timeline-header__poster');

        this.timestamps = [];

        this.init();
    }

    util__parseTime(timestamp){
        let parts = timestamp.split(':');
        let seconds = Number(parts[0]) * 60 + Number(parts[1]);
        return(seconds.toFixed(3));
    }

    util__hasPosterLoaded(){
        return (this.posterElm.complete) ? true : false
    }

    util__loadVideo(){
        const sourceElm = this.videoElm.querySelector('source');

        const srcUrl = sourceElm.dataset.src;

        sourceElm.src = srcUrl;
        
        window.onload = () => {
            this.videoElm.load();

            this.videoElm.addEventListener('canplaythrough', () => {
                this.videoElm.play();
                this.domNode.classList.add('is-playing');
            });
        }
    }

    init(){
        this.init__timestamps();
        this.init__embla();
        this.init__video();

        setTimeout(() => {
            if(this.domNode.classList.contains('is-playing')) return;

            const sourceElm = this.videoElm.querySelector('source');

            const srcUrl = sourceElm.dataset.src;

            sourceElm.src = srcUrl;

            this.videoElm.load();

            this.videoElm.addEventListener('canplaythrough', () => {
                this.videoElm.play();
                this.domNode.classList.add('is-playing');
            });
        }, 5000);
    }

    init__embla(){
        if(!isSet(this.emblaElm)) return;

        this.emblaViewportElm = this.emblaElm.querySelector('.embla__viewport');
        if(!isSet(this.emblaViewportElm)) return;

        this.emblaSlideElms = this.emblaViewportElm.querySelectorAll('.embla__slide');
        if(!isSet(this.emblaSlideElms) || this.emblaSlideElms.length === 0) return;

        this.emblaOptions = {
            loop: true,
            watchDrag: false,
            watchFocus: false,
            align: 'start'
        }

        this.emblaApi = EmblaCarousel(
            this.emblaViewportElm, 
            this.emblaOptions,
            [ClassNames()]
        );

        const loadImagesInView = setupLazyLoadImage(this.emblaApi);

        this.emblaApi
            .on('init', loadImagesInView)
            .on('reInit', loadImagesInView)
            .on('slidesInView', loadImagesInView)
    }

    init__video(){
        if(this.domNode.classList.contains('is-playing')) return;

        this.videoElm.addEventListener('ended', this.onVideoEnded.bind(this));
        this.videoElm.addEventListener('timeupdate', this.onVideoTimeUpdate.bind(this));

        if(this.util__hasPosterLoaded()){
            this.util__loadVideo();
        } else{
            this.posterElm.addEventListener('onload', this.onPosterLoaded.bind(this));
        }
    }

    init__timestamps(){
        this.timestampElms.forEach((timestampElm, i, arr) => {
            const linkedProductId = timestampElm.dataset.linkedProduct;

            const startMetaElm = timestampElm.querySelector('[data-timestamp-start]');
            const endMetaElm = timestampElm.querySelector('[data-timestamp-end]');

            const startTime = this.util__parseTime(startMetaElm.getAttribute('content'));
            const endTime = this.util__parseTime(endMetaElm.getAttribute('content'));

            const timestamp = {
                'product' : linkedProductId,
                'start' : startTime,
                'end' : endTime,
                'triggered' : false
            }

            this.timestamps.push(timestamp);
        })
    }

    reset__timestamps(){
        this.timestamps.forEach((timestamp, i, arr) => {
            timestamp.triggered = false;
        });
    }

    onPosterLoaded(){
        this.util__loadVideo();
    }

    onVideoEnded(){
        this.reset__timestamps();
        this.videoElm.play();
    }

    onVideoTimeUpdate(){
        const activeTimestamp = this.timestamps.find(timestamp => !timestamp.triggered && timestamp.start <= this.videoElm.currentTime && timestamp.end >= this.videoElm.currentTime);

        if(activeTimestamp){
            activeTimestamp.triggered = true;
            this.getNextEmblaSlide(activeTimestamp);
        }
    }

    getNextEmblaSlide(timestamp){
        const timestampProductId = timestamp.product;
        const slideNodes = this.emblaApi.slideNodes();
        const currentSlideIndex = this.emblaApi.selectedScrollSnap();
        const slicedSlideNodesForward = slideNodes.slice(currentSlideIndex);

        let nextIndex = slicedSlideNodesForward.findIndex(node => node.dataset.product === timestampProductId);

        if(nextIndex !== -1){
            this.emblaApi.scrollTo(currentSlideIndex + nextIndex);
        } else if(currentSlideIndex > 0){
            nextIndex = slideNodes.findIndex(node => node.dataset.product === timestampProductId);
            if (nextIndex !== -1) this.emblaApi.scrollTo(nextIndex);
        }
    }
}
  
exports.TimelineVideo = TimelineVideo